import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';
import NavigationLinkSection from './navigation-link-section';

const config = {
    selectors: {
        root: '.navigation',
        body: 'body',
        mainNav: '.navigation__main-nav',
        mainItems: '.navigation__main-nav-item',
        childItem: '.navigation__child',
        childContent: '.navigation__child-content',
        childNavWrapper: '.navigation__child-nav-wrapper',
        childNavClose: '.navigation__child-nav-close',
        burger: '.navigation__action--burger',
        mainNavMobileClose: '.navigation__main-nav-mobile-header-close',
        mainNavMobileIndicator: '.navigation__main-nav-mobile-header-indicator',
        mainNavMobileHeader: '.navigation__main-nav-mobile-header',
        mainNavMobileIndicatorTitle: '.navigation__main-nav-mobile-header-indicator-title',
        childContentMobileClose: '.navigation__child-content-mobile-close',
        childNavContainer: '.navigation__child-nav-container',
        backdrop: '.navigation__child-nav-wrapper-backdrop',
        megaMenu: '.navigation__megamenu',
        mainNavItemNoChilds: '.navigation__main-nav-item--nochild',
        mobileSearch: '.navigation__mobile-search-input',
        mobileSearchContent: '.navigation__mobile-search-content',
        mobileOverlay: '.navigation__child-nav-wrapper--mobile-overlay',
        mainNavLink: '.navigation__main-nav-link',
        mobileHeader: '.navigation__main-nav-mobile-header',
        mobileCountryContent: '.navigation__mobile-country-content',
        countryActionChangeTrigger: '.navigation__country-action-change-trigger',
        countWrapper: '.navigation__action-count',
        countInner: '.navigation__action-count-inner',
        mobileCountWrapper: '.navigation__mobile-action-count',
        mobileCountInner: '.navigation__mobile-action-count-inner',
    }, 
    dataAttributes: {
        childId: 'child-id',
        subchildId: 'subchild-id',
        subchildName: 'subchild-name',
        url: 'url',
    },
    classNames: {
        bodyNoScroll: 'body--no-scroll-new',
        mainItemActive: 'navigation__main-nav-item--active',
        mainItemNonTransparent: 'navigation__main-nav-item--non-transparent',
        childContentActive: 'navigation__child-content--active',
        childNavWrapperActive: 'navigation__child-nav-wrapper--active',
        childNavWrapperVisible: 'navigation__child-nav-wrapper--visible',
        mainNavOpen: 'navigation__main-nav--open',
        linkGroupHeadlineActive: 'navigation-link-groups__group-headline--active',
        childItemActive: 'navigation__child--active',
        indicatorVisible: 'navigation__main-nav-mobile-header-indicator--visible',
        mainNavMobileHeaderVisible: 'navigation__main-nav-mobile-header--visible',
        scrollDown: 'navigation--scrolldown',
        scrollUp: 'navigation--scrollup',
        mobileSearchContentActive: 'navigation__mobile-search-content--active',
        mobileOverlayActive: 'navigation__child-nav-wrapper--mobile-active',
        searchMobileText: 'navigation__mobile-search-text',
        searchMobileIcon: 'navigation__mobile-search-text-icon',
        mainNavMobileHeaderWhite: 'navigation__main-nav-mobile-header--white',
        mainNavItemNoChilds: 'navigation__main-nav-item--nochild',
    },
    titles: {
        countryTitle: 'Country & Language',
    }
};

export class Navigation {
    static canChangeScrollBehavior = true;

    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._shouldClose = false;
        this._windowWidth = window.innerWidth;
        this._url = '';
        this._isOpening = false;
        this._isClosing = false;
        // this._lastScrollY = 0;
        this._lastScrollY = undefined;
        this._isOpened = false;
        this._activeItem = null;
        this._timer = null;
        this._activeIndex = undefined;
        this._mobileSearchText = "Start typing to search karlstorz.com";
    }

    init() {
        this._mobileSearchText = this._$rootElement.data('mobile-search-text') || this._mobileSearchText;
        NavigationLinkSection.sort();
        this._elements = this._getDomElements();
        this._addEventListeners();
        this._scrollNav();
        this.__setDefaultActive();

      
        this.__addsearchChilds();
        //Navigation.updateCartNumber();

        // this._elements.$megaMenu.each((i,item) => {
        //     const $item = $(item);
        //     console.log("navigation", $item)

        //     if(i !== 0) {
        //         $item.height(0);
        //     }
        // });
    }

    _getDomElements() {
        return {
            $body: $('body'),
            $html: $('html'),
            $mainItem: this._$rootElement.find(config.selectors.mainItems),
            $mainNav: this._$rootElement.find(config.selectors.mainNav),
            $burger: this._$rootElement.find(config.selectors.burger),
            $childItem: this._$rootElement.find(config.selectors.childItem),
            $childNavClose: this._$rootElement.find(config.selectors.childNavClose),
            $childContent: this._$rootElement.find(config.selectors.childContent),
            $childNavWrapper: this._$rootElement.find(config.selectors.childNavWrapper),
            $mainNavMobileClose: this._$rootElement.find(config.selectors.mainNavMobileClose),
            $mainNavMobileIndicator: this._$rootElement.find(config.selectors.mainNavMobileIndicator),
            $mainNavMobileIndicatorTitle: this._$rootElement.find(config.selectors.mainNavMobileIndicatorTitle),
            $childContentMobileClose: this._$rootElement.find(config.selectors.childContentMobileClose),
            $navigationRoot: this._$rootElement.find(config.selectors.root),
            $childNavContainer: this._$rootElement.find(config.selectors.childNavContainer),
            $backdrop: this._$rootElement.find(config.selectors.backdrop),
            $megaMenu: this._$rootElement.find(config.selectors.megaMenu),
            $mainNavItemNoChilds: this._$rootElement.find(config.selectors.mainNavItemNoChilds),
            $mobileSearch: this._$rootElement.find(config.selectors.mobileSearch),
            $mobileSearchContent: this._$rootElement.find(config.selectors.mobileSearchContent),
            $mainNavMobileHeader: this._$rootElement.find(config.selectors.mainNavMobileHeader),
            $mainNavMobileHeaderVisible: this._$rootElement.find(config.classNames.mainNavMobileHeaderVisible),
            $mobileOverlay: this._$rootElement.find(config.selectors.mobileOverlay),
            $mainNavLink: this._$rootElement.find(config.selectors.mainNavLink),
            $mobileHeader: this._$rootElement.find(config.selectors.mobileHeader),
            $countryActionChangeTrigger: this._$rootElement.find(config.selectors.countryActionChangeTrigger),
            $mobileCountryContent: this._$rootElement.find(config.selectors.mobileCountryContent),
            $count: this._$rootElement.find(config.selectors.count),
            $mobileCount: this._$rootElement.find(config.selectors.mobileCount),
        };
    }


    _addEventListeners() {
        this._addDesktopEventListeners();
        this._addMobileEventListeners();
     
        //adrian fragen ob es eine gute lösung ist?
        // $(window).on('resize', () => {

        //     this._windowWidth = window.innerWidth;
        //     if(this._windowWidth < 992){
              
                
        //         // location.reload();
        //     }
        //  } )

        $('.navigation-link-section__link').on('click', (e) => {
            e.stopPropagation();
        });
    }

    _addDesktopEventListeners() {
        const _this = this;

        $('.navigation__child-content').on('focusin', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) return;

            const id = $(this).data('subchild-id');

            if(_this._activeSubchildIndex === id) return;

            _this._elements.$childItem.removeClass(config.classNames.childItemActive);
            $(this).addClass(config.classNames.childItemActive);

            _this._activeSubchildIndex = id;

            _this._elements.$childContent.removeClass(config.classNames.childContentActive);
            _this._elements.$childContent.each((i, el) => {
                if($(el).data(config.dataAttributes.subchildId) === id ) {
                    $(el).addClass(config.classNames.childContentActive);
                    $(el).css('height', $(el)[0].scrollHeight);
                    let prevHeight = $(el)[0].scrollHeight;
                } else {
                    $(el).css('height', 0);
                }
            })
        });

        this._elements.$mainItem.on('focusin', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) return;
            
            if($(this).data('child-id') === _this._activeIndex) return;
            
            const isNoParent = $(this).hasClass(config.classNames.mainNavItemNoChilds);

            if(isNoParent) {
                e.stopPropagation();
    
                _this._activeIndex = undefined;
                _this._closeDesktopNav();
                _this._activeItem = null;
                this._isOpened = false;
                
                return false;
            }
            
            e.stopPropagation();

            const $currentItem = $(e.currentTarget);

            if(_this._isOpened) {
                _this._closeDesktopNav();
            }

            _this._openDesktopNav($(this));
            _this._isOpened = true;
            _this._activeItem = $currentItem;
        });

        this._$rootElement.find('.cta-button').on('click', (e) => {
            e.stopPropagation();
        })

        this._elements.$mainItem.on('click', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) return;
            const isNoParent = $(this).hasClass(config.classNames.mainNavItemNoChilds);

            if(_this._isDesktopNav() && !$(e.target).hasClass('cta-button') && !isNoParent) {
                e.preventDefault();
            }
        });
      
        this._elements.$mainItem.on('mouseenter', function(e) {
            if(_this._isDesktopNav()) {
                //console.log('mouseenter');
                const element = e.currentTarget;
                // track mousemove after mouseenter
                $(this).on('mousemove', function(e) {
                  //  console.log('mousemove after mouseenter');
                    clearTimeout(element.timeout);  

                    element.timeout = setTimeout(() => {
                    //    console.log('mouse didnt move for 250ms - open the flyout');
                        clearTimeout(element.timeout);

                        if($(this).data('child-id') === _this._activeIndex) return;
                        
                        if(!($(e.target).hasClass('navigation__main-nav-item') || $(e.target).hasClass('navigation__main-nav-link') || $(e.target).hasClass('navigation__main-nav-link-inner'))) {
                            e.stopPropagation();
                            return false;
                        }
                        
                        const isNoParent = $(this).hasClass(config.classNames.mainNavItemNoChilds);
        
                        if(isNoParent) {
                            e.stopPropagation();
                
                            _this._activeIndex = undefined;
                            _this._closeDesktopNav();
                            _this._activeItem = null;
                            this._isOpened = false;
                            
                            return false;
                        }
                        
                        e.stopPropagation();

                        const $currentItem = $(e.currentTarget);

                        if(_this._isOpened) {
                            _this._closeDesktopNav();
                        }
                        
                        _this._openDesktopNav($(this));
                        clearTimeout(element.timeout);
                        _this._isOpened = true;
                        _this._activeItem = $currentItem;
                      
                    }, 25);  
                });

                $(this).on('mouseleave', function(e) {
                    //console.log('mouseleave after mouseenter');
                    $(this).off('mousemove');
                    $(this).off('mouseleave');
                    clearTimeout(element.timeout); 
                });
            }
        });
      
        this._elements.$childNavClose.on('click', function(e) {
            if(_this._isDesktopNav()) {
                _this._$rootElement.addClass('navigation--no-transition');

                e.preventDefault();
                e.stopPropagation();

                _this._activeIndex = undefined;
                _this._closeDesktopNav();

                setTimeout(() => {
                    _this._$rootElement.removeClass('navigation--no-transition');
                }, 5);
                
            }
        });
        
        this._elements.$backdrop.on('mouseenter', function(e) {
            if(_this._isDesktopNav()) {
                e.stopPropagation();

                var ycoordinate = e.clientY;
            
                if(ycoordinate > 110) {
                    _this._shouldClose = true;

                    const timer = setInterval(() => {
                        _this._activeIndex = undefined;
                        _this._closeDesktopNav();
                        clearInterval(timer);
                    }, 2000);

                    $(this).on('mouseleave', function(e) {
                        clearInterval(timer)
                    });
                }
            }
        });

        this._elements.$childNavWrapper.on('mouseenter', function() {
            if(_this._isDesktopNav()) {
                _this._shouldClose = false;
            }
        });

        this._elements.$backdrop.on('click', function(elem) {
            if(_this._isDesktopNav()) {
                _this._$rootElement.addClass('navigation--no-transition');
                elem.preventDefault();
                elem.stopPropagation();
                
                _this._activeIndex = undefined;
                _this._closeDesktopNav();

                _this._$rootElement.removeClass('navigation--no-transition');
            }
        });

        this._elements.$childItem.on('mouseenter', function(e) {
            if(_this._isDesktopNav()) {
                // e.preventDefault();
                e.stopPropagation();

                const id = $(this).data(config.dataAttributes.subchildId);
                // console.log("child id", id);
                // console.log("element child",  _this._elements.$childItem)
                _this._elements.$childItem.removeClass(config.classNames.childItemActive);
                $(this).addClass(config.classNames.childItemActive);

                _this._activeSubchildIndex = id;

                _this._elements.$childContent.removeClass(config.classNames.childContentActive);
                _this._elements.$childContent.each((i, el) => {
                    if($(el).data(config.dataAttributes.subchildId) === id ) {
                        $(el).addClass(config.classNames.childContentActive);
                        $(el).css('height', $(el)[0].scrollHeight);
                        let prevHeight = $(el)[0].scrollHeight;
                    } else {
                        $(el).css('height', 0);
                    }
                })
            }
        });

        this._elements.$childItem.on('focusin', function(e) {
            if(_this._isDesktopNav()) {
                // e.preventDefault();
                e.stopPropagation();

                const id = $(this).data(config.dataAttributes.subchildId);
                // console.log("child id", id);
                // console.log("element child",  _this._elements.$childItem)
                _this._elements.$childItem.removeClass(config.classNames.childItemActive);
                $(this).addClass(config.classNames.childItemActive);

                _this._activeSubchildIndex = id;

                _this._elements.$childContent.removeClass(config.classNames.childContentActive);
                _this._elements.$childContent.each((i, el) => {
                    if($(el).data(config.dataAttributes.subchildId) === id ) {
                        $(el).addClass(config.classNames.childContentActive);
                        $(el).css('height', $(el)[0].scrollHeight);
                        let prevHeight = $(el)[0].scrollHeight;
                    } else {
                        $(el).css('height', 0);
                    }
                })
            }
        });

        $('.jump-navigation').on('focusin', function(e) {
            _this._$rootElement.addClass(config.classNames.scrollUp);
        });

        this._elements.$childItem.on('keydown', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) return;
            
            if( e.which == 9 ) {
                e.preventDefault();
                const $el = _this._$rootElement.find(`.navigation__child-content[data-subchild-id="${$(this).data('subchild-id')}"]`);
                
                const $links = $el.find('.navigation-link-section__link');
                const $cards = $el.find('.navigation-card-section__card');

                $($links[0]).focus();
                $($cards[0]).focus();

                
                const $teaser = $el.find('.navigation__child-teaser');

                if($teaser.length) {
                    $teaser.find('.cta-button').one('keydown', function(e) {
                        if( e.which == 9 ) {
                            const $el = _this._$rootElement.find(`.navigation__child[data-subchild-id="${_this._activeSubchildIndex}"]`);
                            $el.find('a').focus();
                        }
                    });
                } else {
                    if($links.length) {
                        $($links[$links.length - 1]).one('keydown', function(e) {
                            if( e.which == 9 ) {
                                if(_this._activeSubchildIndex !== _this._$rootElement.find(`.navigation__child`).length - 1) {
                                    const $el = _this._$rootElement.find(`.navigation__child[data-subchild-id="${_this._activeSubchildIndex}"]`);
                                    $el.find('a').focus();
                                }
                            }
                        });
                    } else if($cards.length) {
                        $($cards[$cards.length - 1]).one('keydown', function(e) {
                            if( e.which == 9 ) {
                                if(_this._activeSubchildIndex !== _this._$rootElement.find(`.navigation__child`).length - 1) {
                                    const $el = _this._$rootElement.find(`.navigation__child[data-subchild-id="${_this._activeSubchildIndex}"]`);
                                    $el.find('a').focus();
                                }
                            }
                        });
                    }
                }
            }
        });
    }

    _addMobileEventListeners() {
        const _this = this;
        const mainNavItemDifferendGroup = this._elements.$mainItem[1];

       
        // $('.navigation__mobile-search').on("click", () => {
        //     document.getElementById('mobile').focus()
        //   });

        $(this._elements.$mobileSearch).attr('readonly', '')

   
        this._elements.$mobileSearch.on('click', function(e) {
            _this._elements.$mainNavMobileIndicatorTitle.html("Search");
            _this._elements.$mainNavMobileIndicator.addClass(config.classNames.indicatorVisible);
            _this._elements.$mobileHeader.addClass(config.classNames.mainNavMobileHeaderVisible);
            _this._elements.$mobileSearchContent.addClass(config.classNames.mobileSearchContentActive);

            setTimeout(() => {  
                document.querySelector('.search-bar__text-input').focus() 
            }, 1000);
        });

        this._elements.$countryActionChangeTrigger.on('click', function(e) {
            _this._elements.$mainNav[0].scrollTop = 0;
            _this._elements.$mainNavMobileIndicatorTitle.html(config.titles.countryTitle);
           
            _this._elements.$mainNavMobileIndicator.addClass(config.classNames.indicatorVisible);
            _this._elements.$mobileHeader.addClass(config.classNames.mainNavMobileHeaderVisible);
            //ändern
            $('.overlay--language').addClass('overlay--visible')

            if ( $('.overlay--language').hasClass('overlay--visible')) {
                _this._elements.$mobileHeader.addClass(config.classNames.mainNavMobileHeaderWhite);
                _this._elements.$mainNav.css("overflow-y", "hidden");
                
            } 
        });

        this._elements.$childItem.on('click', function(e) {
            e.stopPropagation();

            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                e.preventDefault();
                const id = $(this).data(config.dataAttributes.subchildId);
                const title = $(this).data(config.dataAttributes.subchildName);

                _this._elements.$mainNav[0].scrollTop = 0;


                _this._elements.$mainNavMobileIndicatorTitle.html(title);
                _this._elements.$mainNavMobileIndicator.addClass(config.classNames.indicatorVisible);
                _this._elements.$mobileHeader.addClass(config.classNames.mainNavMobileHeaderVisible);
                _this._elements.$mainNav.css("overflow-y", "hidden");

                _this._elements.$childItem.removeClass(config.classNames.childItemActive);
                $(this).addClass(config.classNames.childItemActive);
                _this._elements.$childContent.removeClass(config.classNames.childContentActive);
                
                _this._elements.$childContent.each((i, el) => {
                    if($(el).data(config.dataAttributes.subchildId) === id) {
                        $(el).addClass(config.classNames.childContentActive);
                    }
                }) 
            }
        });
        
        this._elements.$mainNavMobileIndicator.on('click', function(e) {
            _this._elements.$mainNavMobileIndicator.removeClass(config.classNames.indicatorVisible);
            _this._elements.$mainNavMobileHeader.removeClass(config.classNames.mainNavMobileHeaderVisible);
            _this._elements.$childItem.removeClass(config.classNames.childItemActive);
            _this._elements.$childContent.removeClass(config.classNames.childContentActive);
            _this._elements.$mobileOverlay.removeClass(config.classNames.mobileOverlayActive);
            _this._elements.$mobileHeader.removeClass(config.classNames.mainNavMobileHeaderVisible);
            _this._elements.$mobileSearchContent.removeClass(config.classNames.mobileSearchContentActive)
              //ändern
            $('.overlay--language').removeClass('overlay--visible')
            _this._elements.$mobileHeader.removeClass(config.classNames.mainNavMobileHeaderWhite);
            _this._elements.$mainNav.css("overflow-y", "scroll")
        });
       
        //mit adrian noch mal drauf schauen gibt bestimmt bessere lösung
        mainNavItemDifferendGroup.addEventListener('click', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                e.preventDefault();
                e.stopPropagation();
                const linkText = _this._elements.$mainNavLink[1].innerHTML;
                _this._elements.$mobileHeader.addClass(config.classNames.mainNavMobileHeaderVisible);
                _this._elements.$mainNavMobileIndicatorTitle.html(linkText);
                _this._elements.$mainNavMobileIndicator.addClass(config.classNames.indicatorVisible);
                _this._elements.$mobileOverlay.addClass(config.classNames.mobileOverlayActive)        
            }
        })
         //ändern close ovlery by clicking at mobile cross
        $('.navigation__close-btn').on('click', function() {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                if($('.overlay--language').hasClass('overlay--visible')) {
                    _this._elements.$mainNavMobileIndicatorTitle.html("");
                }
                
                $('.overlay--language').removeClass('overlay--visible');
            }
        })



        this._elements.$burger.on('click', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                e.preventDefault();
                e.stopPropagation();

                _this._openMobileNav();
            }
        });

        this._elements.$mainNavMobileClose.on('click', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                e.preventDefault();
                e.stopPropagation();
                _this._elements.$mainNav.css("overflow-y", "scroll")
                _this._closeMobileNav();
            }
        });

        this._elements.$childContentMobileClose.on('click', function(e) {
            if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                e.preventDefault();
                e.stopPropagation();
                _this._elements.$mainNav.css("overflow-y", "scroll")
                
                $(this).parent().removeClass(config.classNames.childContentActive);
            }
        });
    }

    _isDesktopNav() {
        return Breakpoints.isBreakpoint('md') || Breakpoints.isBreakpoint('mdlg') || Breakpoints.isBreakpoint('lg') || Breakpoints.isBreakpoint('xl') || Breakpoints.isBreakpoint('xxl');
    }

    _openDesktopNav($el) {
        if($el.data('child-id') === this._activeIndex) return;

        this._activeIndex = $el.data('child-id');
        this._lastScrollY = window.scrollY;
        //console.log('window y', window.scrollY);
        
        this._elements.$body.addClass(config.classNames.bodyNoScroll);
        this._elements.$body.css('top', `${-this._lastScrollY}px`);

        $el.addClass(config.classNames.mainItemActive);

        setTimeout(() => {
            $el.addClass(config.classNames.mainItemNonTransparent);
        }, 200);
        
        

        // remove scroll version 
        $(config.selectors.root).removeClass(config.classNames.scrollUp);
        $(config.selectors.root).removeClass(config.classNames.scrollDown);  
    }

    _closeDesktopNav() {
        //console.log('close desktop nav');

        //console.log('setIsOpened to ', false);
        const html = document.querySelector('html');

        this._elements.$body.removeClass(config.classNames.bodyNoScroll);
        this._elements.$mainItem.removeClass(config.classNames.mainItemNonTransparent);
        this._elements.$mainNavItemNoChilds.removeClass(config.classNames.mainItemNonTransparent);
        this._elements.$mainItem.removeClass(config.classNames.mainItemActive);
        this._elements.$mainNavItemNoChilds.removeClass(config.classNames.mainItemActive);

        html.style.scrollBehavior = 'auto';
        this._elements.$body.css('top', '');

        if( this._lastScrollY != undefined) {
            window.scrollTo(0, this._lastScrollY); // fix scroll position after page was not scrollable
            html.style.scrollBehavior = 'smooth';
            this._lastScrollY = undefined
        }
    }

    _onDesktopSubnavSwitch() {
        // save height of prev submenu
        // get height of new submenu 

        //make animation that adjust the height of parent b< content to use smooth animation
    }

    _openMobileNav() {
        this._elements.$mainNav.addClass(config.classNames.mainNavOpen);
        this._elements.$body.addClass(config.classNames.bodyNoScroll);
        this._elements.$html.addClass(config.classNames.bodyNoScroll);
    }

    _closeMobileNav() {
        this._elements.$mainNav.removeClass(config.classNames.mainNavOpen);
        this._elements.$body.removeClass(config.classNames.bodyNoScroll);
        this._elements.$html.removeClass(config.classNames.bodyNoScroll);
    }

    _scrollNav() {
        let prevScrollpos = window.pageYOffset;
        let currentScrollPos = window.pageYOffset;
        let offsetNavigation = 110;
       const _this = this

        $(window).on('scroll', (e) => {
            if(!Navigation.canChangeScrollBehavior) return;

            currentScrollPos = window.pageYOffset;
            _this._elements.$mobileHeader.addClass('scroll')

            if (currentScrollPos === 0) {
                _this._elements.$mobileHeader.removeClass('scroll')
            }

            const navi = $(config.selectors.root);
  
            if (currentScrollPos > prevScrollpos   && currentScrollPos > offsetNavigation ) {
                // add scrolldown class and remove scrollup class, when currentscrollpos bigger then prevscrollpos

                navi.addClass(config.classNames.scrollDown);
                
                navi.removeClass(config.classNames.scrollUp);

            } else if (currentScrollPos < prevScrollpos ) {
                // remove scrolldown class and add scrollup class, when currentscrollpos smaller then prevscrollpos

                navi.removeClass(config.classNames.scrollDown);
                navi.addClass(config.classNames.scrollUp);
            } 

            
            prevScrollpos =  currentScrollPos;
            
            // if current scroll position at 0 remove class
            if (currentScrollPos === 0) {
                navi.removeClass(config.classNames.scrollUp)
            }
        });

        
    }

    __setDefaultActive() {
        if(Breakpoints.isBreakpoint('md') || Breakpoints.isBreakpoint('mdlg') || Breakpoints.isBreakpoint('lg') || Breakpoints.isBreakpoint('xl') || Breakpoints.isBreakpoint('xxl')) {
            //set nav child item default active
            this._elements.$childItem.each((i, el) => {
                if(i === 0) {
                  $(el).addClass(config.classNames.childItemActive);
                }
              
            });
            //set nav child item content default active
            this._elements.$childContent.each((i, el) => {
                if(i === 0){
                    $(el).addClass(config.classNames.childContentActive);
                    $(el).css('height', '100%');
                }
            })
        }

        Breakpoints.onBreakpointChange(() => {
            if(Breakpoints.isBreakpoint('md') || Breakpoints.isBreakpoint('mdlg') || Breakpoints.isBreakpoint('lg') || Breakpoints.isBreakpoint('xl') || Breakpoints.isBreakpoint('xxl')) {
                //set nav child item default active
                this._elements.$childItem.each((i, el) => {
                    if(i === 0) {
                      $(el).addClass(config.classNames.childItemActive);
                    }
                  
                });
                //set nav child item content default active
                this._elements.$childContent.each((i, el) => {
                    if(i === 0){
                        $(el).addClass(config.classNames.childContentActive);
                        $(el).css('height', '100%');
                    }
                })
            } else if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
                this._elements.$childItem.removeClass(config.classNames.childItemActive);
                this._elements.$childContent.removeClass(config.classNames.childContentActive);
            }
        })
       
    }

    __addsearchChilds() {
  
        if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
            var searchContent = this._elements.$mobileSearchContent;

            if( document.querySelector('.navigation__mobile-search-content').childNodes.length <= 3 ) {
                var searchOverlayText = document.createElement('p');
                var searchIcon = document.createElement('i');     
                searchOverlayText.setAttribute('class', config.classNames.searchMobileText);
                searchContent[0].appendChild(searchOverlayText)
                searchIcon.setAttribute('class', config.classNames.searchMobileIcon);
                searchOverlayText.innerText = this._mobileSearchText;
                searchOverlayText.appendChild(searchIcon);
                
                $( ".search-bar__text-input" ).on('input', (e) => {
                    const inputVal = e.currentTarget.value;
                    if (inputVal.length === 0) {
                        $(searchOverlayText).css('opacity', '1')
                    } else {
                        $(searchOverlayText).css('opacity', '0')
                    }
                })
                $('.search-bar__clear-search-icon').on('click', () => {
                    $(searchOverlayText).css('opacity', '1')
                })
            }

        }
      
    }

    static updateCartNumber(basketCount) {

        if(!basketCount) return;
        
        let $countElt = basketCount.trim();
        $countElt = $countElt.substring(0, 2);

        if (basketCount.trim().length == 0) {
            // basket is empty. we check if there are already visible counts
            if ($(config.selectors.countWrapper).children().length > 0) {
                // we found them, so we just remove them and return
                $(config.selectors.countWrapper).html("");
                $(config.selectors.mobileCountWrapper).html("");
            }
            return;
        }

        // At this point, we do have a count, so we just update all places

        // First we check if there insnt already a count
        if ($(config.selectors.countWrapper).children().length == 0) {
            // we did not found any, so we first attach the element for desktop variant
            $(config.selectors.countWrapper).html(`<span>${$countElt}</span>`);
            // then we clone the elt, change the class of the elt & attach it for mobile
            $(config.selectors.mobileCountWrapper).html(`<span>${$countElt}</span>`);

            // We updated all places, so we just return
            return;
        }

        // We do already have elements, so we just swap the content with response value
        $(config.selectors.countWrapper + '> span').text($countElt);
        $(config.selectors.mobileCountInner + '> span').text($countElt);
    }
}

moduleRegistry.registerModule('Navigation', Navigation);
moduleRegistry.autoApplyModule('Navigation', config.selectors.root);
